(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceManagementActionController', InstanceManagementActionController);

    InstanceManagementActionController.$inject = ['$uibModalInstance', 'InstancesService', 'AlertService', 'entity'];

    function InstanceManagementActionController($uibModalInstance, InstancesService, AlertService, entity) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAction = confirmAction;
        vm.entity = entity;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmAction() {
            console.log(entity);
            InstancesService.executeAction(entity.instance, entity.action).success(function (response) {
                $uibModalInstance.close(true);
            }).error(function (error, status) {
                AlertService.error(error.detail);
                $uibModalInstance.close(true);
            });
        }
    }
})();
